import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "period-switch"
};
var _hoisted_2 = {
  class: "cycle"
};
import { watch, ref } from 'vue';
/**
 * 周期筛选组件
 */

export default {
  __name: 'index',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var currentPeriodName = ref('');
    watch(function () {
      return props.columns;
    }, function (val) {
      if (val) {
        var _val$;
        currentPeriodName.value = (_val$ = val[0]) === null || _val$ === void 0 ? void 0 : _val$.content;
      }
    }, {
      immediate: true,
      deep: true
    });
    var handleChange = function handleChange(item) {
      currentPeriodName.value = item.content;
      emit('change', item.value);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dropdown = _resolveComponent("t-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_dropdown, {
        options: props.columns,
        placement: "bottom-right",
        "max-column-width": 240,
        trigger: "click",
        onClick: handleChange
      }, {
        default: _withCtx(function () {
          var _props$columns;
          return [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(currentPeriodName.value) + " ", 1), !props.loading && (_props$columns = props.columns) !== null && _props$columns !== void 0 && _props$columns.length ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            size: "16",
            name: "swaps",
            class: "right_icon"
          })) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["options"])]);
    };
  }
};